(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frequently-bought-together"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fbt-widget')) {
    class FbtWidget extends HTMLElement {
      async connectedCallback() {
        this.moneyFormat = this.getAttribute('data-money-format') || '{{amount}}';
        this.cartAddUrl = this.getAttribute('data-cart-add-url');
        this.cartUrl = this.getAttribute('data-cart-url');

        // NOTE: the base/current product's own data is read from THIS live
        // element's attributes (rendered by the real page load, where the
        // Liquid `product` object is reliable) - never from the fetched
        // recommendations fragment below, whose isolated render context
        // does not guarantee `product` resolves to the same thing. See the
        // {% comment %} note at the top of this file's Liquid.
        const baseItem = {
          variantId: this.getAttribute('data-base-variant-id'),
          price: this.getAttribute('data-base-price'),
          compareAtPrice: this.getAttribute('data-base-compare-at-price'),
          title: this.getAttribute('data-base-title'),
          image: this.getAttribute('data-base-image'),
          imageAlt: this.getAttribute('data-base-image-alt'),
        };

        const fetchUrl = this.getAttribute('data-url');
        let recItems = [];

        if (fetchUrl) {
          try {
            const response = await fetch(fetchUrl);
            if (response.ok) {
              const text = await response.text();
              const parsed = document.createElement('div');
              parsed.innerHTML = text;
              const parsedWidget = parsed.querySelector('fbt-widget');
              const recWrap = parsedWidget ? parsedWidget.querySelector('.fbt-recs') : null;
              if (recWrap) {
                recItems = Array.from(recWrap.querySelectorAll('.fbt-rec'))
                  .map((el) => ({
                    variantId: el.getAttribute('data-variant-id'),
                    price: el.getAttribute('data-price'),
                    compareAtPrice: el.getAttribute('data-compare-at-price'),
                    title: el.getAttribute('data-title'),
                    available: el.getAttribute('data-available') === 'true',
                    image: el.getAttribute('data-image'),
                    imageAlt: el.getAttribute('data-image-alt'),
                  }))
                  .filter((item) => item.variantId && item.available);
              }
            }
          } catch (error) {
            console.error('FBT recommendations fetch failed', error);
          }
        }

        if (!baseItem.variantId || recItems.length === 0) {
          // Nothing to show (no eligible recommendations for this product,
          // or the fetch failed) - leave the section hidden, same as when
          // there was nothing configured under the old static setup.
          return;
        }

        this.renderWidget(baseItem, recItems);

        const outer = this.closest('[data-fbt-outer]');
        if (outer) outer.hidden = false;
      }

      escapeHtml(value) {
        return (value || '').replace(/[&<>"']/g, (char) => ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;',
        }[char]));
      }

      priceRowHtml(item) {
        const compare = parseFloat(item.compareAtPrice || '0');
        const price = parseFloat(item.price || '0');
        const compareHtml = compare > price
          ? '<s class="fbt__row-compare">' + this.formatMoney(item.compareAtPrice) + '</s>'
          : '';
        return compareHtml + this.formatMoney(item.price);
      }

      thumbHtml(item) {
        const img = item.image
          ? '<img src="' + item.image + '" alt="' + this.escapeHtml(item.imageAlt) + '" loading="lazy" width="100" height="100">'
          : '';
        return '<div class="fbt__thumb">' + img + '</div>';
      }

      renderWidget(baseItem, recItems) {
        const heading = this.getAttribute('data-heading') || '';
        const headingSize = this.getAttribute('data-heading-size') || 'h3';
        const buttonLabel = this.getAttribute('data-button-label') || 'Add selected to cart';

        const thumbsHtml = [this.thumbHtml(baseItem)]
          .concat(recItems.map((item) => '<span class="fbt__plus" aria-hidden="true">+</span>' + this.thumbHtml(item)))
          .join('');

        const recRowsHtml = recItems.map((item) => (
          '<label class="fbt__row">'
          + '<input type="checkbox" class="fbt__checkbox" checked'
          + ' data-variant-id="' + item.variantId + '" data-price="' + item.price + '"'
          + ' aria-label="Add ' + this.escapeHtml(item.title) + ' to bundle">'
          + '<span class="fbt__row-text"><span class="fbt__row-title">' + this.escapeHtml(item.title) + '</span></span>'
          + '<span class="fbt__row-price">' + this.priceRowHtml(item) + '</span>'
          + '</label>'
        )).join('');

        this.innerHTML =
          '<h2 class="fbt__heading ' + headingSize + '">' + this.escapeHtml(heading) + '</h2>'
          + '<div class="fbt__card">'
          + '<div class="fbt__thumbs">' + thumbsHtml + '</div>'
          + '<div class="fbt__list">'
          + '<label class="fbt__row fbt__row--base">'
          + '<input type="checkbox" class="fbt__checkbox" checked disabled'
          + ' data-variant-id="' + baseItem.variantId + '" data-price="' + baseItem.price + '"'
          + ' aria-label="' + this.escapeHtml(baseItem.title) + ' (always included)">'
          + '<span class="fbt__row-text">'
          + '<span class="fbt__row-label">This item</span>'
          + '<span class="fbt__row-title">' + this.escapeHtml(baseItem.title) + '</span>'
          + '</span>'
          + '<span class="fbt__row-price">' + this.priceRowHtml(baseItem) + '</span>'
          + '</label>'
          + recRowsHtml
          + '</div>'
          + '<div class="fbt__summary">'
          + '<p class="fbt__total">'
          + '<span class="fbt__total-label">Total price:</span>'
          + '<span class="fbt__total-price">'
          + '<s class="fbt__total-compare" data-fbt-total-compare hidden></s>'
          + '<span data-fbt-total></span>'
          + '</span>'
          + '</p>'
          + '<button type="button" class="fbt__add-button button" data-fbt-add-button>' + this.escapeHtml(buttonLabel) + '</button>'
          + '<p class="fbt__status" role="status" aria-live="polite" data-fbt-status></p>'
          + '</div>'
          + '</div>';

        this.checkboxes = Array.from(this.querySelectorAll('.fbt__checkbox'));
        this.totalEl = this.querySelector('[data-fbt-total]');
        this.totalCompareEl = this.querySelector('[data-fbt-total-compare]');
        this.addButton = this.querySelector('[data-fbt-add-button]');
        this.statusEl = this.querySelector('[data-fbt-status]');

        this.checkboxes.forEach((checkbox) => {
          checkbox.addEventListener('change', this.updateTotal.bind(this));
        });

        if (this.addButton) {
          this.addButton.addEventListener('click', this.addSelectedToCart.bind(this));
        }

        this.updateTotal();
      }

      formatMoney(cents) {
        const amount = (parseFloat(cents || '0') / 100).toFixed(2);
        const parts = amount.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        const formatted = parts.join('.');
        return this.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, formatted);
      }

      updateTotal() {
        // NOTE: Shopify Liquid price fields (variant.price, etc.) are already
        // expressed in the shop's smallest currency unit (cents), so the
        // data-price attribute is already in cents — do NOT multiply by 100
        // again here, or totals come out 100x too high.
        let totalCents = 0;
        this.checkboxes.forEach((checkbox) => {
          if (checkbox.checked) {
            const price = parseFloat(checkbox.getAttribute('data-price') || '0');
            totalCents += Math.round(price);
          }
        });

        if (this.totalCompareEl) {
          this.totalCompareEl.hidden = true;
        }
        if (this.totalEl) {
          this.totalEl.textContent = this.formatMoney(totalCents);
        }
      }

      async addSelectedToCart() {
        const items = this.checkboxes
          .filter((checkbox) => checkbox.checked)
          .map((checkbox) => ({
            id: parseInt(checkbox.getAttribute('data-variant-id'), 10),
            quantity: 1,
          }));

        if (items.length === 0) return;

        this.addButton.setAttribute('disabled', 'disabled');
        const originalLabel = this.addButton.textContent;
        this.addButton.textContent = 'Adding…';
        if (this.statusEl) this.statusEl.textContent = '';

        try {
          // NOTE: this.cartAddUrl comes from the data-cart-add-url attribute
          // rendered in the HTML - it already has the required ".js" suffix
          // appended server-side by Liquid, since Liquid can't be
          // interpolated here in the {% javascript %} block.
          const response = await fetch(this.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });

          if (!response.ok) {
            // NOTE: Read the response as text first (not response.json()
            // directly) because a failing request can come back as HTML
            // (e.g. a proxy/app/error page) instead of JSON - calling
            // .json() straight away would throw and hide that entirely.
            const rawBody = await response.text().catch(() => '');
            let errorData = {};
            try {
              errorData = rawBody ? JSON.parse(rawBody) : {};
            } catch (parseErr) {
              errorData = {};
            }
            // NOTE: Shopify's /cart/add.js error JSON is not always shaped the
            // same way - single-item stock errors use `.description`, but other
            // failures (e.g. a validation app, a checkout function, or a
            // malformed items array) can come back as `.message`, as a plain
            // `.errors` string, or as an `.errors` object keyed by field. Check
            // every shape so the real reason reaches the customer (and us)
            // instead of always falling back to the same generic text.
            let message = errorData.description || errorData.message;
            if (!message && errorData.errors) {
              if (typeof errorData.errors === 'string') {
                message = errorData.errors;
              } else if (typeof errorData.errors === 'object') {
                message = Object.values(errorData.errors).flat().join(' ');
              }
            }
            console.error('FBT add to cart failed', response.status, rawBody);
            // NOTE: The status code is appended to the VISIBLE message (not
            // just logged to console) so the real cause can be read straight
            // off a screenshot, since live browser debugging isn't always
            // available while iterating on this.
            if (!message) {
              message = 'Could not add items to cart (server responded with status '
                + response.status + ').';
            }
            throw new Error(message);
          }

          document.dispatchEvent(new CustomEvent('cart:refresh'));

          if (this.statusEl) {
            this.statusEl.innerHTML =
              'Added to your cart. <a href="' + this.cartUrl + '">View cart</a>';
          }
          this.addButton.textContent = 'Added ✓';
          setTimeout(() => {
            this.addButton.textContent = originalLabel;
            this.addButton.removeAttribute('disabled');
          }, 2500);
        } catch (error) {
          if (this.statusEl) {
            this.statusEl.textContent = error.message || 'Something went wrong. Please try again.';
          }
          this.addButton.textContent = originalLabel;
          this.addButton.removeAttribute('disabled');
        }
      }
    }

    customElements.define('fbt-widget', FbtWidget);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('track-order-widget')) {
    class TrackOrderWidget extends HTMLElement {
      connectedCallback() {
        this.endpoint = this.getAttribute('data-endpoint') || '';
        this.form = this.querySelector('[data-track-order-form]');
        this.submitButton = this.querySelector('[data-track-order-submit]');
        this.statusEl = this.querySelector('[data-track-order-status]');
        this.resultEl = this.querySelector('[data-track-order-result]');
        this.numberEl = this.querySelector('[data-track-order-number]');
        this.dateEl = this.querySelector('[data-track-order-date]');
        this.financialBadgeEl = this.querySelector('[data-track-order-financial-badge]');
        this.fulfillmentBadgeEl = this.querySelector('[data-track-order-fulfillment-badge]');
        this.trackingEl = this.querySelector('[data-track-order-tracking]');
        this.trackingDetailsEl = this.querySelector('[data-track-order-tracking-details]');
        this.trackingLinkEl = this.querySelector('[data-track-order-tracking-link]');

        if (this.form) {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      async handleSubmit(event) {
        event.preventDefault();
        if (!this.endpoint) return;

        const formData = new FormData(this.form);
        const orderNumber = (formData.get('order_number') || '').toString().trim();
        const email = (formData.get('email') || '').toString().trim();

        if (!orderNumber || !email) return;

        this.setBusy(true);
        if (this.resultEl) this.resultEl.hidden = true;
        if (this.statusEl) this.statusEl.textContent = '';

        try {
          const response = await fetch(this.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ order_number: orderNumber, email: email }),
          });

          const data = await response.json().catch(() => null);

          if (!response.ok || !data || data.found !== true) {
            if (this.statusEl) {
              this.statusEl.textContent =
                "We couldn't find an order matching that number and email. Please double-check and try again.";
            }
            this.setBusy(false);
            return;
          }

          this.renderResult(data);
        } catch (error) {
          if (this.statusEl) {
            this.statusEl.textContent = 'Something went wrong while looking up your order. Please try again shortly.';
          }
        } finally {
          this.setBusy(false);
        }
      }

      setBusy(isBusy) {
        if (!this.submitButton) return;
        if (isBusy) {
          this.submitButton.setAttribute('aria-busy', 'true');
          this.submitButton.setAttribute('disabled', 'disabled');
        } else {
          this.submitButton.removeAttribute('aria-busy');
          this.submitButton.removeAttribute('disabled');
        }
      }

      renderResult(data) {
        if (this.numberEl) {
          this.numberEl.textContent = data.order_number ? 'Order ' + data.order_number : 'Order found';
        }
        if (this.dateEl) {
          this.dateEl.textContent = data.placed_on ? 'Placed ' + data.placed_on : '';
        }
        if (this.financialBadgeEl) {
          this.financialBadgeEl.textContent = data.financial_status_label || '';
        }
        if (this.fulfillmentBadgeEl) {
          this.fulfillmentBadgeEl.textContent = data.fulfillment_status_label || '';
        }

        if (data.tracking_number || data.tracking_company) {
          if (this.trackingEl) this.trackingEl.hidden = false;
          if (this.trackingDetailsEl) {
            const parts = [];
            if (data.tracking_company) parts.push(data.tracking_company);
            if (data.tracking_number) parts.push('#' + data.tracking_number);
            this.trackingDetailsEl.textContent = parts.join(' ');
          }
          if (this.trackingLinkEl) {
            if (data.tracking_url) {
              this.trackingLinkEl.href = data.tracking_url;
              this.trackingLinkEl.hidden = false;
            } else {
              this.trackingLinkEl.hidden = true;
            }
          }
        } else if (this.trackingEl) {
          this.trackingEl.hidden = true;
        }

        if (this.resultEl) this.resultEl.hidden = false;
        if (this.statusEl) this.statusEl.textContent = '';
      }
    }

    customElements.define('track-order-widget', TrackOrderWidget);
  }

  } catch(e) { console.error(e); }
})();
})();
